import { SVGProps } from 'react';

const CornerLeftUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4 9 5-5 5 5M9 4v12a4 4 0 0 0 4 4h7"
    />
  </svg>
);
export default CornerLeftUp;
